import React from 'react'

import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { ArrowBigIcon } from '@application/Interfaces/Icons'
import { Nullable } from '@src/Application/Types/Opt'

import { Disabled, Link, PaginationWrapper, Separator } from './Pagination.styled'

type Props = {
    prevPage: Nullable<string>
    nextPage: Nullable<string>
}

export const Pagination = ({ prevPage, nextPage }: Props): Nullable<JSX.Element> => {
    const { t } = useTranslation()

    if (!prevPage && !nextPage) {
        return null
    }

    return (
        <PaginationWrapper>
            {prevPage ? (
                <Link to={prevPage}>
                    <ArrowBigIcon direction="left" /> {t('previousPage')}
                </Link>
            ) : (
                <Disabled>
                    <ArrowBigIcon direction="left" /> {t('previousPage')}
                </Disabled>
            )}
            <Separator />
            {nextPage ? (
                <Link to={nextPage}>
                    {t('nextPage')} <ArrowBigIcon />
                </Link>
            ) : (
                <Disabled>
                    {t('nextPage')} <ArrowBigIcon />
                </Disabled>
            )}
        </PaginationWrapper>
    )
}
